import { render, staticRenderFns } from "./costEdit.vue?vue&type=template&id=54c96658&scoped=true&"
import script from "./costEdit.vue?vue&type=script&lang=js&"
export * from "./costEdit.vue?vue&type=script&lang=js&"
import style0 from "./costEdit.vue?vue&type=style&index=0&id=54c96658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c96658",
  null
  
)

export default component.exports